module.exports = __webpack_public_path__ + "img/10ten-labs-kv.92909628.jpg";